import { render, staticRenderFns } from "./GameCollectionDetailBlueTheme.vue?vue&type=template&id=498b3a97"
import script from "./GameCollectionDetailBlueTheme.vue?vue&type=script&lang=js"
export * from "./GameCollectionDetailBlueTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports